import React from 'react';
import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { CopilotChat, CopilotProvider, CopilotProviderProps, UserMessage } from '@fluentui-copilot/react-copilot';
import { IStyledComponent } from 'common/Common.types';

import { useCopilot } from './hooks/UseCopilot';
import { chatTokens } from './Chat.styles';
import { ChatHistoryItemResponse } from './ChatHistoryItemResponse';
import { ChatInput } from './ChatInput';
import { CopilotStarter } from './CopilotStarter';

interface IChatControlProp extends IStyledComponent, Pick<CopilotProviderProps, 'mode'> {
  question?: string;
  showDebugInfo?: boolean;
  hideChatInput?: boolean;
}

export const ChatControl = (props: IChatControlProp) => {
  // i18next-extract-mark-ns-start copilot

  const { question, className, styles, showDebugInfo = false, hideChatInput = false, mode = 'sidecar' } = props;
  const scrollDiv = React.useRef<HTMLDivElement>(null);
  const { history } = useCopilot();

  // scroll to the last message whenever history is updated
  React.useEffect(() => {
    scrollDiv.current?.scrollTo({ top: scrollDiv.current.scrollHeight });
  }, [history]);

  return (
    <FluentProvider theme={{ ...webLightTheme, colorNeutralBackground1: 'transparent' }}>
      <CopilotProvider mode={mode}>
        <Stack tokens={chatTokens.root} className={className} styles={styles}>
          <CopilotStarter />
          <Stack.Item>
            <CopilotChat ref={scrollDiv}>
              {history.map((item) => (
                <React.Fragment key={item.id}>
                  <UserMessage>{item.question}</UserMessage>
                  <ChatHistoryItemResponse item={item} showDebugInfo={showDebugInfo} />
                </React.Fragment>
              ))}
            </CopilotChat>
          </Stack.Item>
          {!hideChatInput && <ChatInput question={question} />}
        </Stack>
      </CopilotProvider>
    </FluentProvider>
  );

  // i18next-extract-mark-ns-stop copilot
};
